import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-management",
  "use": "icon-management-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-management\"><path d=\"M1024 832v-64h-56.96a166.4 166.4 0 0 0-28.8-67.84l39.68-40.96-38.4-39.04-40.32 40.96A160.64 160.64 0 0 0 832 633.6V576h-64v56.96a166.4 166.4 0 0 0-67.84 28.8l-40.96-39.68-39.04 38.4 40.96 40.32A160.64 160.64 0 0 0 633.6 768H576v64h56.96a166.4 166.4 0 0 0 28.8 67.84l-39.68 40.96 38.4 39.04 40.32-40.96A160.64 160.64 0 0 0 768 966.4v57.6h64v-56.96a166.4 166.4 0 0 0 67.84-28.8l40.96 39.68 39.04-38.4-40.96-40.32A160.64 160.64 0 0 0 966.4 832z m-224 51.84A83.84 83.84 0 1 1 883.84 800 83.84 83.84 0 0 1 800 883.84z\" p-id=\"3535\" /><path d=\"M512 0a239.36 239.36 0 1 0 239.36 239.36A239.36 239.36 0 0 0 512 0zM0 990.72V1024h592.64a352 352 0 0 1 80-519.04A512 512 0 0 0 0 990.72z\" p-id=\"3536\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/management.svg
// module id = bZrc
// module chunks = 80